import { useEffect, useState } from 'react';

interface ScrollAnimationOptions {
  intensity?: number;
  maxScroll?: number;
}

export function useScrollAnimation(options: ScrollAnimationOptions = {}) {
  const { intensity = 0.05, maxScroll = 1000 } = options;
  const [scrollY, setScrollY] = useState(0);
  
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(Math.min(window.scrollY, maxScroll));
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [maxScroll]);
  
  const getTransform = (baseValue: number, factor: number) => {
    return baseValue + (scrollY * intensity * factor);
  };
  
  const isElementVisible = (elementTop: number, threshold = 100) => {
    return scrollY > elementTop - window.innerHeight + threshold;
  };
  
  return { scrollY, getTransform, isElementVisible };
}